import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const SignOutOtherDevicesModal = ({ isOpen, onClose, onConfirm, email, password }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { signOutOtherDevices } = useAuth();

  const handleConfirm = async () => {
    setLoading(true);
    setError('');

    try {
      // Use AuthContext signOutOtherDevices to properly update context
      await signOutOtherDevices(email, password);
      onConfirm();
    } catch (err) {
      setError(err.response?.data?.message || 'Échec de la déconnexion des autres appareils');
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-[#1A1A1A] border border-[#262626] rounded-2xl p-6 sm:p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold text-white mb-4">
          Session active détectée
        </h2>
        
        <p className="text-gray-300 mb-6">
          Vous êtes déjà connecté sur un autre appareil. Pour vous connecter ici, vous devez vous déconnecter de l'autre appareil.
        </p>

        {error && (
          <div className="mb-4 p-3 bg-red-900/50 border border-red-700 rounded text-red-200 text-sm">
            {error}
          </div>
        )}

        <div className="flex gap-4">
          <button
            onClick={onClose}
            disabled={loading}
            className="flex-1 px-6 py-3 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition font-semibold disabled:opacity-50"
          >
            Annuler
          </button>
          <button
            onClick={handleConfirm}
            disabled={loading}
            className="flex-1 px-6 py-3 bg-white text-gray-900 rounded-lg hover:bg-gray-100 transition font-semibold disabled:opacity-50"
          >
            {loading ? 'Déconnexion...' : 'Déconnecter l\'autre appareil'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignOutOtherDevicesModal;
